import withHttp from '@/config/withHttp';
var baseURL = '/judgeagent';
/* *************** 庭审中相关接口 ******************* */

var apis = {
  // 开始庭审
  startTrial: {
    url: '/client/trial/start',
    method: 'post'
  },
  // 开始会议
  startConference: {
    url: '/client/conference/start',
    method: 'post'
  },
  // 停止会议
  stopConference: {
    url: '/client/conference/stop',
    method: 'post'
  },
  // 踢出会议
  kickoutConference: {
    url: '/client/conference/kickout',
    method: 'post'
  },
  // 重新邀请入会
  enableConference: {
    url: '/client/conference/enableMember',
    method: 'post'
  },
  // 禁用/启用音视频
  ctrlConferenceMultimediaStatus: {
    url: '/client/conference/ctrl',
    method: 'post'
  },
  // 获取参会人员
  members: {
    url: '/client/conference/members',
    method: 'post'
  },
  // 发起核验
  compare: {
    url: '/client/face/compare',
    method: 'post'
  },
  // 发起笔录确认
  confirm: {
    url: '/client/sign/confirm',
    method: 'post'
  },
  // 接口保活
  heartbeat: {
    url: '/heartbeat',
    method: 'post'
  },
  // 获取会议参数appId和appkey
  vcsParams: {
    url: '/client/vcs/param',
    method: 'get'
  },
  // 重新邀请加入
  enableMember: {
    url: '/client/conference/enableMember',
    method: 'post'
  },
  // 获取笔录信息
  getNote: {
    url: '/client/note',
    method: 'get'
  },
  // 更新庭审状态
  trialStatus: {
    url: '/client/trial/status',
    method: 'post'
  },
  // 更新闭庭后的排期
  updatePlanEndTime: {
    url: '/client/trial/updatePlanEndTime',
    method: 'post'
  },
  // 获取排期详情
  scheduleById: {
    url: '/schedule/scheduleById',
    method: 'post'
  },
  // 上传庭审笔录
  uploadNote: {
    url: '/client/note/upload',
    method: 'post'
  },
  // 下载庭审笔录
  downloadNote: {
    url: '/client/downLoad',
    method: 'get'
  },
  // 加入房间
  enterRoom: {
    url: '/client/conference/enter',
    method: 'post'
  },
  // 退出房间
  exitRoom: {
    url: '/client/conference/exit',
    method: 'post'
  },
  // 获取庭审时间
  timeCount: {
    url: '/client/trial/timeCount',
    method: 'get'
  },
  // 获取vcs登录信息
  getVcsInfo: {
    url: '/eits/web/getVcsLogInfo',
    method: 'post'
  }
};
export default withHttp(apis, baseURL);